<template>
    <div class="childbannertwo-box" id='childbannertwo'>
        <div class="captionBox">
            <div class="caption-boxs">
                <h3 class="caption" :class="{isShows:isShow}">{{headerBannerData.caption}}</h3>
            </div>
            <!-- <span class="encaption">{{headerBannerData.encaption}}</span> -->
            <ul class="carbreh-ul">
                <li class="carbreh-li" :class="{isShows:isShow}"
                    v-for='(item,index) in headerBannerData.carbreh.slice(0,2)'><a :href="item.url">{{item.name}}</a>
                </li>
                <li class="carbreh-li" :class="{isShows:isShow}">{{headerBannerData.carbreh.slice(2)[0].name}}</li>
            </ul>
        </div>
        <div class="childNav">
            <ul class="navul">
                <li class="navitem-li" v-for='(item,index) in childNav' :key='index' :class="{isActive:index===active}">
                    <a :href="item.url"><span>{{item.chinaname}}</span><span>{{item.enname}}</span></a></li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ChildbannerTwo',
        data() {
            return {
                active: 0,//选中序号
                isShow: false,
                headerBannerData: {//banner面包屑
                    caption: 'solution ',
                    // encaption: 'solution ',
                    carbreh: [
                        {
                            name: '首页',
                            url: '/'
                        },
                        {
                            name: '解决方案',
                            url: '/program'
                        }
                    ]
                },
                childNav: [//子导航
                    {
                        chinaname: '定制网站',
                        enname: 'WEBSITE',
                        url: '/program'
                    },
                    {
                        chinaname: '谷歌广告',
                        enname: 'google',
                        url: '/program/google'
                    },
                    {
                        chinaname: '社媒推广',
                        enname: 'SNS',
                        url: '/program/social'
                    },
                    {
                        chinaname: 'SEO优化',
                        enname: 'SEO',
                        url: '/program/seo'
                    },
                    {
                        chinaname: '邮件营销',
                        enname: 'EDM',
                        url: '/program/email'
                    },
                    {
                        chinaname: '视频拍摄',
                        enname: 'video',
                        url: '/program/solution'
                    },
                ]
            }
        },
        mounted() {
            this.getUrl()
        },
        methods: {
            changeShow() {
                this.isShow = true
            },
            getUrl() {//根据路由改变标题内容
                let path = this.$route.path
                switch (path) {
                    case '/program':
                        this.headerBannerData.caption = 'Custom Websites'
                        this.active = 0
                        this.headerBannerData.carbreh.push({
                            name: '定制网站',
                            url: '/program'
                        })
                        break
                    case '/program/google':
                        this.headerBannerData.caption = 'Google Ads'
                        this.active = 1
                        this.headerBannerData.carbreh.push({
                            name: '谷歌广告',
                            url: '/program/google'
                        })
                        break
                    case '/program/social':
                        this.headerBannerData.caption = 'SNS Marketing'
                        this.active = 2
                        this.headerBannerData.carbreh.push({
                            name: '社媒推广',
                            url: '/program/social'
                        })
                        break
                    case '/program/seo':
                        this.headerBannerData.caption = 'SEO'
                        this.active = 3
                        this.headerBannerData.carbreh.push({
                            name: 'SEO优化',
                            url: '/program/seo'
                        })
                        break
                    case '/program/email':
                        this.headerBannerData.caption = 'EDM'
                        this.active = 4
                        this.headerBannerData.carbreh.push({
                            name: '邮件营销',
                            url: '/program/email'
                        })
                        break
                    case '/program/solution':
                        this.headerBannerData.caption = 'VIDEO MARKETING'
                        this.active = 5
                        this.headerBannerData.carbreh.push({
                            name: '视频拍摄',
                            url: '/program/solution'
                        })
                        break
                }
            }
        }
    }
</script>
<style scoped>
    .childbannertwo-box {
        height: 700px;
        background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/paola-ocaranza-iv3-QAMmJOU-unsplash.jpg') no-repeat center;
        background-size: cover;
        position: relative;
        /* background-attachment: fixed; */
        /* margin-bottom: 344px; */
    }

    .captionBox {
        padding: 255px 0 0 7.6%;
    }

    .caption-boxs {
        overflow: hidden;
    }

    .caption-boxs .caption {
        text-transform: uppercase;
        position: relative;
        top: 0;
        transform: translateY(100%);
        transition: all 1.5s ease-in-out;
        font-size: 98px;
        font-family: gilroybold4;
        font-weight: bold;
        line-height: 121%;
        color: rgba(255, 255, 255, 1);

    }

    .caption-boxs .isShows {
        transform: translateY(0%);
    }

    .encaption {
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        color: rgba(255, 255, 255, 1);
        text-transform: uppercase;
        display: block;
        margin-top: 10px;
    }

    .carbreh-ul {
        display: flex;
        margin-top: 10px;
        overflow: hidden;
    }

    .carbreh-li {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: rgba(255, 255, 255, 1);
        position: relative;
        top: 0;
        transform: translateY(100%);
        transition: all 1.8s ease-in-out;
    }

    .carbreh-ul .isShows {
        transform: translateY(0%);
    }

    .carbreh-li:not(:last-child) {
        color: #CCCCCC;
        border-right: 1px solid #CCCCCC;
    }

    .carbreh-li:not(:first-child) {
        padding: 0 20px;
    }

    .carbreh-li:first-child {
        padding-right: 20px;
    }


    .carbreh-li>a {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: #CCCCCC;
        transition: all 0.5s;
    }

    .carbreh-li>a:hover {
        color: #ffffff;
    }

    .childNav {
        width: 79.1%;
        height: 110px;
        background-color: #1c1c1c;
        position: absolute;
        bottom: -55px;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 4;
    }

    .navul {
        width: 100%;
        padding: 0 15%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .navitem-li {
        height: 22px;
        position: relative;
    }

    /* .navitem-li:not(:last-child) {
        margin-right: 134px;
    } */

    .navitem-li>a {
        display: block;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .navitem-li>a>span {
        display: block;
        color: #999999;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        text-transform: uppercase;
        transition: all 0.5s;

    }

    .navitem-li:hover span {
        color: #ffffff;
        transform: translateY(-100%);
    }

    .navitem-li::after {
        content: "";
        display: block;
        height: 0px;
        border: none;
        width: 1px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 150%);
        background-color: #ffffff;
        transition: all 0.5s;
    }

    .navitem-li:hover::after {
        height: 12px;
    }

    /* 选中效果 */
    .isActive>a>span {
        color: #ffffff;
    }

    @media(max-width: 995px) {
        .captionBox {
            padding: 0%;
            position: absolute;
            width: 100%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .childbannertwo-box {
            height: 100vh;
            background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20200802103126.jpg') no-repeat center;
            background-size: cover;
            background-attachment: initial;
            position: relative;
        }

        .childbannertwo-box .caption {
            text-align: center;
            font-size: 35px;
        }

        .carbreh-ul {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0;
            margin-top: 10px;
            overflow: hidden;
        }

        .childNav {
            width: 100%;
            height: auto;
            padding: 5% 0;
            background-color: #1c1c1c;
            position: absolute;
            bottom: 0;
            right: 0;
        }

        .navul {
        width: 100%;
        padding: 0 2%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

        /* .caption-boxs .caption {
        transform: translateY(100%);
        transition: all 1.5s ease-in-out;
        font-size: 35px;
        line-height: 121%;

    } */
    }

    /* @media(max-width: 1023px) {
        .childbannertwo-box {
            height: 1500px;
            background-attachment: initial;
        }

        .carbreh-li>a {
            font-size: 50px;
            line-height: 142%;
        }

        .carbreh-li {
            font-size: 50px;
            line-height: 142%;
        }

        .captionBox {
            padding: 855px 0 0 47px;
        }

        .childNav {
            width: 100%;
            height: 210px;
        }
        .navul {
        width: 100%;
        justify-content: space-between;
    }
        .navitem-li {
            height: 100px;
        }

        .navitem-li:not(:last-child) {
            margin-right: 0;
        }

        .navitem-li>a>span {
            font-size: 50px;
            line-height: 100px;

        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/base/childbannertwo.vue